export default __webpack_public_path__ + "static/media/app-store-black.7a3a9a50.svg";